import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { SiGeeksforgeeks, SiCodechef, SiLeetcode, SiGithub } from 'react-icons/si';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/Anupam0202">
        <SiGithub />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/anupam-roy111a">
        <BsLinkedin />
      </a>
    </div>
    <div>
      <a href="https://auth.geeksforgeeks.org/user/glitteringunicorn/profile">
        <SiGeeksforgeeks />
      </a>
    </div>
    <div>
      <a href="https://www.codechef.com/users/anupam0202">
        <SiCodechef />
      </a>
    </div>
    <div>
      <a href="https://leetcode.com/anupam020202/">
        <SiLeetcode />
      </a>
    </div>
  </div>
);

export default SocialMedia;
